import React from 'react'

type AnimationState = {
  isAnimating: boolean
  currentIndex: number
  hasAutoExpanded: boolean
  hasAutoCollapsed: boolean
}

export const useAnimationState = (
  stepId: string,
  enableAnimation: boolean,
  isInProgress: boolean,
  tasksLength: number,
) => {
  const [state, setState] = React.useState<AnimationState>({
    isAnimating: false,
    currentIndex: 0,
    hasAutoExpanded: false,
    hasAutoCollapsed: false,
  })

  // Reset state when step changes
  React.useEffect(() => {
    setState({
      isAnimating: false,
      currentIndex: 0,
      hasAutoExpanded: false,
      hasAutoCollapsed: false,
    })
  }, [stepId])

  // Handle animation state changes
  React.useEffect(() => {
    if (!enableAnimation) {
      setState((prev) => ({ ...prev, currentIndex: tasksLength - 1, isAnimating: false }))
      return
    }

    if (isInProgress && !state.isAnimating) {
      setState((prev) => ({ ...prev, isAnimating: true }))
    }
  }, [enableAnimation, isInProgress, tasksLength, state.isAnimating])

  const setIndex = React.useCallback((index: number) => {
    setState((prev) => ({ ...prev, currentIndex: index }))
  }, [])

  const markAutoExpanded = React.useCallback(() => {
    setState((prev) => ({ ...prev, hasAutoExpanded: true }))
  }, [])

  const markAutoCollapsed = React.useCallback(() => {
    setState((prev) => ({ ...prev, hasAutoCollapsed: true, isAnimating: false }))
  }, [])

  return {
    ...state,
    setIndex,
    markAutoExpanded,
    markAutoCollapsed,
  }
}
